import { render, staticRenderFns } from "./settingsUserView.vue?vue&type=template&id=05751efb"
import script from "./settingsUserView.vue?vue&type=script&lang=js"
export * from "./settingsUserView.vue?vue&type=script&lang=js"
import style0 from "./settingsUserView.vue?vue&type=style&index=0&id=05751efb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports